import script from "./Changelog.vue?vue&type=script&setup=true&lang=ts"
export * from "./Changelog.vue?vue&type=script&setup=true&lang=ts"

import "./Changelog.vue?vue&type=style&index=0&id=b5743ecc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5743ecc"]])

export default __exports__